import Alert from 'react-s-alert'

export const renderAlert = (msg, method = 'warning') =>
  Alert[method](msg, {
    position: 'top-right',
    effect: 'jelly',
    timeout: 5000,
  })



// WEBPACK FOOTER //
// ./src/services/render-alert.js